import { render, staticRenderFns } from "./CbsTresDeposit.vue?vue&type=template&id=756bb16c&scoped=true"
import script from "./CbsTresDeposit.vue?vue&type=script&lang=js"
export * from "./CbsTresDeposit.vue?vue&type=script&lang=js"
import style0 from "./CbsTresDeposit.vue?vue&type=style&index=0&id=756bb16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756bb16c",
  null
  
)

export default component.exports